export default __webpack_public_path__ + "static/media/collapsible-app-bar-snap.44e5cfb8.gif";